import { Controller } from "@hotwired/stimulus"

// Knowledge document form: show only the field that matches the chosen source
// type. Without this all three inputs are visible at once, and it's easy to
// paste text, pick "File", and get a validation error that reads like a bug.
export default class extends Controller {
  static targets = ["select", "text", "url", "file"]

  connect() {
    this.update()
  }

  update() {
    const type = this.selectTarget.value

    this.textTarget.hidden = type !== "text"
    this.urlTarget.hidden = type !== "url"
    this.fileTarget.hidden = type !== "file"
  }
}
